<template>
    <!-- Categories -->
    <section class="py-5">
        <div class="container">
            <div class="d-flex justify-content-between align-items-center mb-4">
                <h2 class="fw-bold font-serif">Sub Categories</h2>
                <a href="#" class="text-decoration-none text-dark small fw-bold">View All <i
                        class="bi bi-arrow-right-circle-fill text-brown"></i></a>
            </div>
            <div class="row g-4 text-center">
                <!-- Category Item -->
                <div class="col-6 col-md-2" v-for="category in categories" :key="category.id">
                    <a :href="'/category/' + category.slug" class="text-decoration-none text-dark">
                        <div class="cat-circle bg-light rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center">
                            <img :src="category.image ? category.image.small : 'https://placehold.co/100x100/transparent/8D6E63?text=' + category.name" 
                                    class="cat-img img-fluid"
                                    :alt="category.name"
                                    style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;">
                        </div>
                        <h6 class="fw-bold small">{{ category.name }}</h6>
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "CategoriesSection",
    props: {
        categories: {
            type: Array,
            required: true
        }
    }
}
</script>
